import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const unownedCentresOfUserSelectors = crudSelectorsCustom(MODEL_NAME);
